<template>
  <div class="companion" @mouseover="stop" @mouseout="start">
    <h3>相关机构</h3>
    <div class="container" ref="box">
      <div class="rolling" :style="{left: left + 'px', width: w + 'px'}">
        <div class="service" v-for="item in businessList" :key="item.basicId" @click="goUrl(item.basicId)">
          <div class="imgbox">
            <img :src="$store.state.baseUrl+item.basicThumbnails" alt />
          </div>
          <span style="font-size:6px">{{item.basicTitle}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      businessList: [],
      left: 0,
      t: "",
      w: 0,
      isRoll: false
    };
  },
  computed: {
    ...mapGetters(["getCategoryAppid"])
  },
  watch: {
    getCategoryAppid(id) {
      this.getBusinessList(id);
    }
  },
  mounted() {
    this.getBusinessList(this.$store.state.categoryAppid);
  },
  methods: {
    ...mapActions(["findPage", "getArticle"]),
    getBusinessList(id) {
      this.findPage({
        basicCategoryid: 257,
        basicType: id,
        page: 1,
        size: 100
      }).then(res => {
        // console.log(res)
        this.left = 0;
        window.cancelAnimationFrame(this.t);
        var businessList = res.data.dataList;
        // console.log(this.businessList)
        let w = res.data.length * 81;
        if (w > this.$refs.box.clientWidth) {
          let copy = JSON.parse(JSON.stringify(businessList));
          copy.forEach((item, index) => {
            copy[index].categoryId = item.categoryId * 10;
          });
          this.businessList = businessList.concat(copy);
          this.w = this.businessList.length * 81;
          this.rolling();
          this.isRoll = true;
        } else {
          this.businessList = res.data.dataList;
          this.w = this.businessList.length * 81;
        }
      });
    },
    rolling() {
      var that = this;
      function step() {
        that.left--;
        if (that.left == (-1 / 2) * that.w) {
          that.left = 0;
        }
        that.t = window.requestAnimationFrame(step);
      }
      that.t = window.requestAnimationFrame(step);
    },
    goUrl(id) {
      this.getArticle(id).then(res => {
        window.open(res.data.articleUrl, "_blank")
      });
    },
    start() {
      if(this.isRoll) {
        this.rolling()
      }
    },
    stop() {
      if(this.isRoll) {
        window.cancelAnimationFrame(this.t);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  text-align: center;
  padding: 10px;
  border-bottom: 3px solid #018fd7;
  margin-bottom: 10px;
}
.container {
  width: 100%;
  height: 130px;
  overflow: hidden;
  position: relative;
  .rolling {
    height: 130px;
    position: absolute;
  }
  .service {
    // border: solid 1px #999;
    cursor: pointer;
    width: 61px;
    height: 130px;
    margin: 0 10px;
    color: #000;
    float: left;
    align-items: center;
    .imgbox {
      width: 100%;
      height: 60px;
    }
  }
}
</style>
